class BundleForm extends HTMLElement {
  
  constructor() {
    super();
    this.init();

    document.addEventListener('fakeVariant:loaded', () => {
      this.init();
    });
  }

  init() {
    this.form = this.querySelector('.js-bundle-form');
    this.listeners();
  }

  listeners() {
    this.form.addEventListener('submit', (e) => {
      const submitButton = this.querySelector('.js-bundle-submit');
      const currentItem =  this.querySelector('.js-bundle-card-current .js-product-form');
      const bundleItems = this.querySelectorAll('.js-bundle-card-checked .js-product-form');
      
      e.preventDefault();
      
      if (submitButton.getAttribute('disabled')) {
        return;
      }

      this.form.classList.add('is-loading');

      const formData = {
        items: [
          {
            id: parseInt(currentItem.querySelector('input[name="id"]').value),
            quantity: 1
          }
        ]
      };
      
      bundleItems.forEach((el) => {
        formData.items.push({
          id: parseInt(el.querySelector('input[name="id"]').value),
          quantity: 1
        })
      });

      document.dispatchEvent(
        new CustomEvent('cart:add', { 
          detail: {
            data: { formData: JSON.stringify(formData), multiple: true, sections: 'stmt-popout-cart' }
          }
        })
      )
    });

    document.addEventListener('variant:change', (e) => {;
      const submitButton = this.querySelector('.js-bundle-submit');
      const variant = e.detail.data.variant;

      if (variant) {
        if (variant.available) {
          submitButton.removeAttribute('disabled');
        } else {
          submitButton.setAttribute('disabled', 'disabled');
        }
      }
    });

    document.addEventListener('bundle:addItem', (e) => {
      const productId = e.detail.data.formData.get('productId');
      const currentVariant = e.detail.data.currentVariant;
      const index = e.detail.data.index;

      document.dispatchEvent(
        new CustomEvent('bundle:variantChange', {
          detail: {
            data: {
              productId: productId,
              variant: currentVariant,
              index: index
            }
          }
        })
      )
    });

    document.addEventListener('bundle:updatePrice', () => {
      this.updatePrice();
    });
  }

  updatePrice() {
    const currentItem =  this.querySelector('.js-bundle-card-current .js-product-form');
    const bundleItems = this.querySelectorAll('.js-bundle-card-checked .js-product-form');
    const bundlePrice = this.querySelector('.js-bundle-price');
    const saving = this.querySelector('.js-bundle-saving');
    
    let totalPrice = parseInt(currentItem.getAttribute('data-variant-price'));
    let totalCompareAtPrice = parseInt(currentItem.getAttribute('data-variant-compare-at-price')) || totalPrice;

    if (totalPrice >= totalCompareAtPrice) {
      totalCompareAtPrice = totalPrice
    }

    bundleItems.forEach((el) => {
      const price = parseInt(el.getAttribute('data-variant-price'));
      const compareAtPrice = parseInt(el.getAttribute('data-variant-compare-at-price'));

      if (price) {
        totalPrice += price;
      }

      if (price < compareAtPrice) {
        totalCompareAtPrice += compareAtPrice;
      } else {
        totalCompareAtPrice += price;
      }
    });

    if (totalPrice < totalCompareAtPrice) {
      bundlePrice.innerHTML = `
        <span class="product-bundle__price product-bundle__price--sale">${Shopify.formatMoney(totalPrice, window.money.format)}</span>
        <s class="product-bundle__price product-bundle__price--compare-at">${Shopify.formatMoney(totalCompareAtPrice, window.money.format)}</s>
      `;

      saving.innerHTML = `${variantStrings.saving.replace('[saving]', Shopify.formatMoney(totalCompareAtPrice - totalPrice, window.money.format))}`;
      saving.classList.remove('product-bundle__details-saving--hidden');
    } else {
      bundlePrice.innerHTML = `
        <span class="product-bundle__price">${Shopify.formatMoney(totalPrice, window.money.format)}</span>
      `;

      saving.classList.add('product-bundle__details-saving--hidden');
    }
  }
}

customElements.define('bundle-form', BundleForm);

class BundleCard extends SiteProductForm {

  constructor() {
    super();
  }

  listeners() {
    const self = this;
    const checkboxes = this.querySelectorAll('.js-bundle-card-checkbox');

    if (this.classList.contains('js-bundle-card-current')) {
      document.addEventListener('variant:change', (e) => {
        const variant = e.detail.data.variant;

        if (variant) {
          this.updateSelectedVariant(variant);
          this.updateWishlistDetails(variant);
        }

        document.dispatchEvent(
          new CustomEvent('bundle:updatePrice')
        )
      });
    } else {
      document.addEventListener('bundle:variantChange', (e) => {
        const variant = e.detail.data.variant;
        const index = e.detail.data.index;

        if (this.getAttribute('data-bundle-index') === index && variant) {
          this.classList.add('product-bundle__card--checked', 'js-bundle-card-checked');
          
          this.updateSelectedVariant(variant);
          this.updateWishlistDetails(variant);
          this.updatePrice();

          document.dispatchEvent(
            new CustomEvent('modal:hide')
          )

          document.dispatchEvent(
            new CustomEvent('bundle:updatePrice')
          )
        }
      });
    }

    checkboxes.forEach((el) => {
      self.classList.toggle('product-bundle__card--checked');
      self.classList.toggle('js-bundle-card-checked');

      document.dispatchEvent(
        new CustomEvent('bundle:updatePrice')
      )
      el.addEventListener('click', () => {
        self.classList.toggle('product-bundle__card--checked');
        self.classList.toggle('js-bundle-card-checked');

        document.dispatchEvent(
          new CustomEvent('bundle:updatePrice')
        )
      });
    })
  }

  updateWishlistDetails(variant) {
    const wishlistDetails = this.querySelector('.bundle-wishlist-details');

    if (!wishlistDetails) return;

    wishlistDetails.innerHTML = JSON.stringify(variant.wishlist);
  }
}

customElements.define('bundle-card', BundleCard);
